import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/base/Breadcrumb";
import SectionHeading from "@/components/base/SectionHeading";
import usePageMeta from "@/hooks/usePageMeta";
import AboutHero from "./components/AboutHero";
import PrinciplesSection from "./components/PrinciplesSection";
import TimelineSection from "./components/TimelineSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";

export default function About() {
  usePageMeta({
    title: "关于我们 · 瓜田热评的内容原则与发展理念",
    description:
      "了解瓜田热评：一个专注热门吃瓜与网友热评的内容整理平台。我们坚持只做整理不做审判、拒绝引战、重视观点，并持续把评论区里有价值的声音挑出来给你看。",
    keywords: "关于瓜田热评,热门吃瓜平台,网友热评整理,吃瓜群,内容原则",
    path: "/about",
    ogType: "website",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于瓜田热评",
      description: "瓜田热评的品牌介绍、内容原则、发展理念与联系方式。",
      inLanguage: "zh-CN",
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "关于我们", item: "/about" },
        ],
      },
      mainEntity: {
        "@type": "Organization",
        name: "瓜田热评",
        email: "hello@guatian-hotcomment.cc",
        slogan: "不只看热闹，更看神评论",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: "hello@guatian-hotcomment.cc",
          availableLanguage: "zh-CN",
        },
      },
    },
  });

  return (
    <Layout>
      <div className="w-full">
        <div className="w-full px-4 pt-8 md:px-8 md:pt-10">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
        </div>

        <AboutHero />

        <section className="w-full px-4 py-12 md:px-8 md:py-16">
          <SectionHeading
            eyebrow="内容原则"
            title="热闹之外，我们也守着三条线"
            desc="内容整理这件事，看起来简单，做起来总要有点坚持。这是我们每天都在提醒自己的三件事。"
          />
          <PrinciplesSection />
        </section>

        <section className="w-full border-y border-background-200 bg-background-100 px-4 py-12 md:px-8 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <SectionHeading
                eyebrow="发展理念"
                title="从收藏夹到每天一封日报"
                desc="七年时间，我们只做了一件事：把评论区里那些值得被看到的观点留下来。"
              />
            </div>
            <div className="lg:col-span-8">
              <TimelineSection />
            </div>
          </div>
        </section>

        <section className="w-full px-4 py-12 md:px-8 md:py-16">
          <SectionHeading
            eyebrow="用户口碑"
            title="围观群众怎么说"
            desc="他们有的是订阅用户，有的是吃瓜群成员。这些评价来自真实反馈的整理。"
          />
          <TestimonialsSection />
        </section>

        <section className="w-full px-4 pb-16 md:px-8 md:pb-20">
          <ContactSection />
        </section>
      </div>
    </Layout>
  );
}